export default function Projects() {
  const approach = [
    {
      icon: 'ri-search-line',
      title: 'Resource Assessments',
      description: 'Prefeasibility studies and waste stream analysis'
    },
    {
      icon: 'ri-tools-line',
      title: 'EPC Partnerships',
      description: 'Engineering, Procurement and Construction collaboration'
    },
    {
      icon: 'ri-funds-line',
      title: 'Financial Structuring',
      description: 'Blended finance and investment mobilization'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Off-taker Agreements',
      description: 'Revenue contracts and commercial partnerships'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Capital Raising',
      description: 'DFIs, climate funds, and private investors'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Venture Investment',
      description: 'Early-stage circular technology start-ups'
    }
  ];

  const markets = [
    {
      country: 'Zimbabwe',
      focus: 'Major Cities',
      description: 'Projects in Bulawayo, Gweru, and other urban centres',
      icon: 'ri-map-pin-line'
    },
    {
      country: 'Botswana',
      focus: 'Water-Stressed Urban Centres',
      description: 'Addressing water scarcity and wastewater challenges in growing cities',
      icon: 'ri-drop-line'
    },
    {
      country: 'SADC Region',
      focus: 'Strategic Markets',
      description: 'Expanding across Southern Africa with scalable circular infrastructure solutions',
      icon: 'ri-global-line'
    }
  ];

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Our Approach
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Full <strong>Project Lifecycle</strong> Leadership
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Kagesi leads every stage of project development, from initial assessment through construction and operation, ensuring bankable and sustainable infrastructure.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {approach.map((item, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-all">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-emerald-600 text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mb-16">
          <div className="text-center mb-12">
            <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Where We Work
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Southern Africa <strong>Development Roadmap</strong>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Our initial focus is Southern Africa, where urgent infrastructure challenges can be transformed into scalable circular economy solutions.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {markets.map((market, index) => (
              <div key={index} className="bg-gradient-to-br from-emerald-50 to-green-50 p-8 rounded-2xl border border-emerald-200">
                <div className="w-14 h-14 bg-emerald-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${market.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{market.country}</h3>
                <p className="text-emerald-700 font-semibold mb-3">{market.focus}</p>
                <p className="text-gray-600 leading-relaxed">{market.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-50 p-10 rounded-2xl border border-gray-200">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">How We Operate</h3>
            <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Kagesi operates through a dual venture-building and project development model. We identify infrastructure opportunities, design commercially viable solutions, structure blended finance, attract strategic partners, invest in circular innovations, and develop fully bankable projects from concept through construction.
            </p>
          </div>
          <div className="bg-emerald-600 text-white p-8 rounded-xl text-center">
            <p className="text-lg font-semibold">
              This approach positions Kagesi as both a developer and an early-stage investor, driving the next generation of circular economy infrastructure in Africa.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}